import React from "react";
import styles from "./SummaryBanner.module.scss";
import { jobDatabaseMetaType } from "../../../Types/jobDatabaseTypes";
import { getSummaryItems } from "./constants";
import clsx from "clsx";
import ConditionalRender from "../../../reusable-components/ConditionalRender";
import { Spin } from "antd";
import { ButtonSize } from "../../../enums/ButtonAttributesEnums";

interface SummaryBannerProps {
  databaseMeta: jobDatabaseMetaType;
  loading?: boolean;
}

const SummaryBanner = ({ databaseMeta, loading }: SummaryBannerProps) => {
  return (
    <div className={styles.detailsCard}>
      <ConditionalRender visible={!loading} fallback={<Spin />}>
        {getSummaryItems(databaseMeta)?.map((item, index) => (
          <div
            key={index}
            className={clsx(styles.summaryItem, {
              [styles.borderRight]: index !== item.flag,
            })}
          >
            <div className={styles.summaryValue}>{item.value}</div>
            <div className={styles.summaryLabel}>{item.label}</div>
          </div>
        ))}
      </ConditionalRender>
    </div>
  );
};

export default SummaryBanner;
